import { Box, Container } from '@mui/system'
import { Typography } from '@mui/material'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ReactComponent as UploadToCloud } from '../../images/UploadToCloud.svg'
import TitleWithCountV2 from '../../components/PageHelpers/TitleWithCountV2'
import SEO from '../../components/PageHelpers/SEO'
import AppRoutes from '../../services/AppRoutes'
import LinkBtn from '../../components/Buttons/LinkBtn'
import UseTranslation from '../../hooks/UseTranslation'
import ConfirmationModalContainerV2 from '../../components/Modals/ConfirmationModalContainerV2'
import { importUsersRolesModalData } from '../../utils/confirmationDataContainer'
import OfoqThemeBtn from '../../components/Buttons/OfoqThemeBtn'
import FinishModalContainerV2 from '../../components/Modals/FinishModalContainerV2'
import { importUsersRolesFinish } from '../../utils/finishDataContiner'
import LoaderWithErrorHandler from '../../components/PageHelpers/LoaderWithErrorHandler'
import { selectImportUsersRoles } from '../../redux/features/importUsersRoles/importUsersRolesSlice'
import { importUsersRolesCreateFile, importUsersRolesResetAlertHandler } from '../../redux/features/importUsersRoles/importUsersRolesThunk'
import OfoqAttachmentInput from '../../components/Forms/OfoqAttachmentInput'
import { attachmentResetAlertHandler } from '../../redux/features/attachment/attachmentThunk'
import { selectAttachment } from '../../redux/features/attachment/attachmentSlice'
import ImportUsersRolesTips from './ImportUsersRolesTips'
import ExampleTemplate from './ExampleTemplate'

const ImportUsersRoles = () => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [finishModalState, setFinishModalState] = useState(false)
  const { t } = UseTranslation()
  const history = useHistory()
  const [attachments, setAttachments] = useState([])
  const importUsersRoles = useSelector(selectImportUsersRoles)

  const attachmentStore = useSelector(selectAttachment)

  return (
    <Box sx={styles.root}>
      <SEO title={t?.['Import User\'s Roles']} description={t?.['Import User\'s Roles']} />
      <Container maxWidth={false} sx={styles.container}>
        <Box sx={styles.wrapperContainer}>
          <Box sx={styles.headerContainer}>
            <TitleWithCountV2
              title={t?.['Import User\'s Roles']}
              icon={<UploadToCloud />}
              iconSize="xl"
              iconColor="warning.dark"
              textVariant="heading2"
              customStyle={styles.headerTitle}
            />
          </Box>

          <Box sx={styles.btnContainer}>
            <LinkBtn
              to={`${AppRoutes.home}`}
              name={<Typography sx={styles.linkTitle}>{t?.Cancel}</Typography>}
              customStyle={styles.cancelStyle}
            />
            <OfoqThemeBtn
              name={<Typography sx={styles.linkTitle}>{t?.Import}</Typography>}
              customStyle={styles.linkBtn}
              onClick={() => setShowConfirmationModal(true)}
              disabled={attachments.length === 0}
            />
          </Box>
        </Box>
        <Box sx={styles.attachmentInputContainer}>
          <OfoqAttachmentInput
            maxCount={1}
            fileTypes={['csv', 'xlsx', 'xls']}
            subBody={t?.['Accepted Types are .xls, .xlsx, .csv. Maximum 1 file']}
            onFilesChange={setAttachments}
            customStyles={styles.attachmentInput}
          />
        </Box>
        <Box sx={styles.tablesContainer}>

          <ImportUsersRolesTips />
          <ExampleTemplate />

        </Box>
      </Container>
      <ConfirmationModalContainerV2
        modalState={showConfirmationModal}
        setModalState={setShowConfirmationModal}
        actionToDispatch={importUsersRolesCreateFile}
        actionQueries={{
          file: attachments[0],
        }}
        modalData={importUsersRolesModalData}
        actionAfterSuccess={() => {
          setFinishModalState(true)
        }}
      />
      <FinishModalContainerV2
        modalState={finishModalState}
        actionAfterSuccess={() => {
          setFinishModalState(false)
          history.push(AppRoutes.home)
        }}
        finishHandler={'FinishHandler'}
        modalData={importUsersRolesFinish}
      >
        <Typography sx={styles.finishMsg}>
       {`${t?.['You can monitor the Processing Status from']} `}
        <Typography component={'span'} sx={styles.finishMsgSpan}
        onClick={() => history.push(AppRoutes.usersBatchActionsStatus)}
        >
         {`${t?.['Batch Action Status Screen']}`}
          </Typography>
        </Typography>

      </FinishModalContainerV2>
      <LoaderWithErrorHandler
        store={importUsersRoles}
        resetAlertHandler={importUsersRolesResetAlertHandler}
      />
       <LoaderWithErrorHandler
        resetAlertHandler={attachmentResetAlertHandler}
        store={attachmentStore}
      />

       <LoaderWithErrorHandler
        resetAlertHandler={attachmentResetAlertHandler}
        store={attachmentStore}
      />
    </Box>
  )
}
const styles = {
  root: {
    marginTop: { xs: '-10px', sm: '-29px' },
    paddingInline: { xs: '10px !important', sm: '18px !important', md: '24px !important' },
  },
  container: {
    padding: { xs: '0px !important', sm: '0px 0px 50px 0px !important' },
  },
  wrapperContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    backgroundColor: 'background.paper',
    height: { xs: '56px', sm: '88px' },
    margin: {
      xs: '0px', sm: '0px 10px 10px 10px', md: '0px 0px 20px 0px', lg: '0px 0px 20px 0px',
    },
    '& .searchIcon': {
      width: '27px',
      height: '27px',
    },
  },
  headerTitle: {
    marginBottom: { xs: '0px !important', sm: '10px' },
    display: 'flex',
    alignItems: { xs: 'center', md: 'flex-end' },
    gap: '10px',
    '& h5': {
      fontFamily: 'Avenir 85 Heavy',
      fontWeight: 500,
      fontSize: { xs: '16px', sm: '24px' },
      lineHeight: { xs: '20.15px', sm: '27.9px' },
      paddingTop: '0px !important',
    },

  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '40px',
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    backgroundColor: 'background.paper',
    p: { xs: 1, sm: '20px', md: '25px' },
  },

  linkTitle: {
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    '& svg': {
      width: { xs: '15px', sm: '12px' },
      height: { xs: '15px', sm: '12px' },
      paddingLeft: '20px',
    },
  },
  btnContainer: {
    position: { xs: 'fixed', sm: 'unset' },
    bottom: 0,
    zIndex: 100,
    right: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: { xs: '100%', sm: 'fit-content' },
    border: { xs: '1px solid grey.200', sm: 'none' },
    backgroundColor: 'background.paper',
    padding: '10px',
    marginRight: { xs: '0px', sm: '0px' },
  },
  linkBtn: {
    boxSizing: 'border-box',
    width: { xs: '95%', sm: '100%' },
    maxWidth: { xs: '100%', sm: 'fit-content' },
    minWidth: { xs: 'unset', sm: '140px' },
    height: '40px',
    color: 'text.main',
    textTransform: 'none',
    mx: { xs: 'auto', sm: '0px' },
    marginRight: { xs: '0px !important', sm: '20px !important' },
    '& p': {
      fontSize: { xs: '12px', sm: '14px' },
      maxWidth: { xs: '196px', sm: '190px' },
      paddingLeft: { xs: '0px', sm: '0px' },
    },
  },
  cancelStyle: {
    display: { xs: 'none', sm: 'flex' },
    boxSizing: 'border-box',
    width: { xs: '95%', sm: '100%' },
    maxWidth: { xs: '100%', sm: 'fit-content' },
    minWidth: { xs: 'unset', sm: '140px' },
    height: { xs: '32px', sm: '40px' },
    mx: { xs: 'auto', sm: '0px' },
    marginRight: { xs: '0px !important', sm: '20px !important' },
    color: 'primary.main',
    backgroundColor: 'primary.light',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'grey.100',
    '& p': {
      fontSize: { xs: '12px', sm: '14px' },
      maxWidth: { xs: '196px', sm: '190px' },
      paddingLeft: { xs: '0px', sm: '0px' },
    },
    '&:hover': {
      color: 'white',
      backgroundColor: 'primary.main',
      borderColor: 'primary.main',
      boxShadow: 'none',
    },
  },
  tablesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginBlock: { xs: '10px', md: '20px' },
  },
  finishMsg: { color: '#92929D', textAlign: 'center', mt: '16px' },
  finishMsgSpan: { color: '#29CC8B', textDecoration: 'underline', cursor: 'pointer' },
  finishModel: {
    height: { xs: 'fit-content', sm: 'auto' },
    transform: { xs: 'translate(-50%, 6%)', sm: 'translate(-50%, -50%)' },
    ' & button': {
      width: { xs: '100%', sm: 'auto' },
    },
  },
  attachmentInputContainer: {
    padding: '20px',
  },
  attachmentInput: {
    paddingTop: { md: '0px !important' },
    borderBottom: '1px solid #e2e8ee',
  },
}
export default ImportUsersRoles
